// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import DashboardOutlined from '/Users/viv/projs/benai-admin/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/DashboardOutlined';
import UserOutlined from '/Users/viv/projs/benai-admin/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/UserOutlined';
import BookOutlined from '/Users/viv/projs/benai-admin/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/BookOutlined';
export default { DashboardOutlined, UserOutlined, BookOutlined };
